import React from "react"
import FontIcon from "material-ui/FontIcon"
import ImageLoader from "../../components/misc/ImageLoader"
import ToolTip from "react-portal-tooltip"
import strings from "../../localization/strings"
interface IProps {
    identity: string
    url: string
}
interface IState {
    open: boolean
}

export default class ImageColumn extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            open: false
        }
    }

    render() {
        return (
            <div className="ImageColumn">
                <ToolTip
                    active={this.state.open}
                    position="left"
                    arrow="center"
                    parent={"#" + "image-" + this.props.identity}
                    key={this.props.identity}
                    group={"image-" + this.props.identity}
                    tooltipTimeout={50}
                >
                    {this.props.url ?
                        <div style={{ height: 250, minWidth: 150 }}>
                            <ImageLoader
                                key={this.props.url}
                                url={this.props.url}
                                fixedHeight={250}
                                src={"/punches/image/" + this.props.url}
                            />
                        </div> :
                        <div style={{ height: 75, minWidth: 150 }}>
                            <div style={{ width: 320, height: 75, textAlign: "center" }}>
                                <h3>{strings.No_image}</h3>
                                <p>{strings.Last_employee_has_not_image}</p>
                            </div>
                        </div>
                    }
                </ToolTip>
                <FontIcon
                    id={"image-" + this.props.identity}
                    className="fa fa-picture-o"
                    style={{ color: !this.props.url && "#cccccc" }}
                    onMouseOver={() => this.setState({ open: true })}
                    onMouseOut={() => this.setState({ open: false })}
                />
            </div>
        )
    }
}
